export function toRenderStructDTOFromArray(render) {
    const renderStructDTO = [];
    for (let i = 0; i < render.length; i++) {
        renderStructDTO.push(toRenderStructDTO(render[i]));
    }
    return renderStructDTO;
}
export function toRenderStructDTO(render) {
    const material = render.material.map((mat) => {
        const m = mat;
        return {
            id: m.uuid,
            color: m.color ? m.color.getHex() : undefined,
            opacity: m.opacity,
            metalness: m.metalness,
        };
    });
    return {
        vertices: render.vertices,
        indices: render.indices,
        uvs: render.uvs,
        group: render.group,
        position: toVec3DTO(render.position),
        rotation: toVec3DTO(render.rotation),
        material,
        elements: render.elements.map(el => ({
            indices: el.indices,
            vertices: el.vertices,
            name: el.name,
            nameGroup: el.nameGroup,
            position: toVec3DTO(el.position),
            rotation: toVec3DTO(el.rotation),
            uvs: el.uvs,
            material: el.material,
        })),
    };
}
export function toVec3DTO(v) {
    if (!v)
        return { x: 0, y: 0, z: 0 };
    return {
        x: v[0],
        y: v[1],
        z: v[2],
    };
}
